import { createSelector } from 'reselect';

import {
  isAuthenticatedWithBookings,
  isMissingBillingDetails,
  isMissingPayoutMethod,
} from 'ha/modules/AuthLogic/selectors';

export default createSelector(
  [isAuthenticatedWithBookings, isMissingPayoutMethod, isMissingBillingDetails],
  (authenticatedWithBookings, missingPayoutMethod, missingBillingDetails) =>
    authenticatedWithBookings && (missingBillingDetails || missingPayoutMethod),
);
